import React from 'react';
import styled from 'styled-components';

import Wrapper from './wrapper';
import { media } from '../helpers';

import Wave from '../../images/waves/home-top-wave.inline.svg';

const WaveBannerContainer = styled.div`
    position: relative;
    .svg-container {
        min-height: 60vh;
        max-width: 100vw;
        position: relative;
        @media (max-width: 400px) {
            min-height: 65vh;
        }
        svg {
            max-width: 100vw;
            width: 100%;
            height: auto;
        }
    }

    .content-container {
        position: absolute;
        left: 0;
        width: 100%;
        top: 10vh;
        max-width: 100vw;
        ${media.small`top: 15vh;`}
        /* ${media.laptop`top: 16vh;`} */
        ${media.xl`top: 15vh;`}
        .inner-wrap {
            text-align: center;
            max-width: 90vw;
            margin: 0 auto;
            ${media.large`max-width: 65vw;`}
            h1 {
                font-family: neue-kabel, sans-serif;
                font-weight: 800;
                font-size: 2.5rem;
                margin: 0 0 15px;
                color: #fff;
                ${media.small`font-size: 3em;`}
                ${media.medium`font-size: 2.5rem;`}
                ${media.large`font-size: 2.8rem;`}
                ${media.laptop`font-size: 4rem;`}
            }

            p {
                font-size: 1rem;
                margin: 0;
                color: #fff;
                line-height: 1.5;
                margin: 0 auto;
                ${media.small`font-size: 1.1rem;`}
                ${media.medium`font-size: 1.2rem;`}
                ${media.laptop`font-size: 1.3rem;`}
                ${media.large`max-width: 950px;`}
            }
        }
    }
`;

const WaveBanner = ({ content }) => {
    const { bannerHeadline, bannerCaption, bannerBgColor } = content || {};
    return (
        <WaveBannerContainer>
            <div
                className="svg-container"
                style={{ backgroundColor: bannerBgColor }}
            >
                <Wave />
            </div>
            <Wrapper className="content-container">
                <div className="inner-wrap">
                    <h1>{bannerHeadline}</h1>
                    <p>{bannerCaption}</p>
                </div>
            </Wrapper>
        </WaveBannerContainer>
    );
};

export default WaveBanner;
